import type ProjectSectionType from 'src/enums/companyProjects/ProjectSectionType';

export const projectContainerQueryKeys = {
  table: () => ['projectContainerTable'] as const,
  tablePage: (
    page: number,
    rowsPerPage: number,
    orderBy: string | undefined,
    isDesc: boolean | undefined,
    filterModel: unknown
  ) => ['projectContainerTable', page, rowsPerPage, orderBy, isDesc, filterModel] as const,
  edit: (projectContainerId: number | undefined) => ['projectContainerEdit', projectContainerId] as const,
  section: (projectContainerId: number | undefined, sectionType: ProjectSectionType | undefined) =>
    ['projectContainerOverview', projectContainerId, 'section', sectionType] as const,
  homeFeed: (projectContainerId: number | undefined) => ['projectContainerHomeFeed', projectContainerId] as const,
  assessment: (projectContainerId: number | undefined) => ['projectContainerAssessment', projectContainerId] as const
};
